<template>
  <v-card class="text-center" flat tile>
    {{
      `${contenidoMayor({
        item: Articulo[0],
      })}`
    }}
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["Articulo"]),
    contenidoMayor: function () {
      return function ({ item: { EnTransito, ContentMayor } }) {
        let division = Math.ceil(EnTransito / ContentMayor);

        return division;
      };
    },
  },
};
</script>

<style></style>
